export default "__VITE_ASSET__HFiXJDls__"